import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, createElement } from "react";
import { THEME } from "../../constants/theme.js";
import { cn as clsx } from "../../helpers/react.js";
import { IconWrapper } from "../IconWrapper/index.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import { s, B as BUTTON_INTENT, a as BUTTON_INTENT_CLASSNAME_MAP } from "../../constants-BLwk9iaK.js";
const Button = withThemeAndSize(
  forwardRef((props, ref) => {
    const {
      as: Component = "button",
      children,
      theme,
      size: _size,
      // omit from `...restProps`
      className,
      containerClassName,
      contentClassName,
      onClick,
      icon,
      rightIcon,
      disabled,
      inline = false,
      fill = false,
      uppercase = false,
      intent = BUTTON_INTENT.SECONDARY,
      ...restProps
    } = props;
    const handleClick = useCallback(
      (event) => {
        if (disabled || !onClick) {
          return;
        }
        onClick(event);
      },
      [disabled, onClick]
    );
    const hasTheme = theme !== THEME.CUSTOM;
    const componentProps = {
      className: clsx(
        s.root,
        {
          [s.disabled]: disabled,
          [s.fill]: fill,
          [s.uppercase]: uppercase
        },
        hasTheme && {
          [s.inline]: inline,
          [s.regular]: !inline,
          [s.withTheme]: true,
          [BUTTON_INTENT_CLASSNAME_MAP[intent]]: true
        },
        className
      ),
      onClick: handleClick,
      disabled,
      ref,
      ...restProps
    };
    if (Component === "button") {
      if (!("type" in componentProps)) {
        componentProps.type = "button";
      }
    } else if ("role" in componentProps) {
      componentProps.role = "button";
    }
    const content = /* @__PURE__ */ jsxs("span", { className: clsx(s.contentContainer, containerClassName), children: [
      icon && /* @__PURE__ */ jsx(IconWrapper, { className: s.iconWrapper, children: icon }),
      children && /* @__PURE__ */ jsx("span", { className: clsx(s.content, contentClassName), children }),
      rightIcon && /* @__PURE__ */ jsx(IconWrapper, { className: s.iconWrapper, children: rightIcon })
    ] });
    return createElement(Component, componentProps, content);
  })
);
Button.displayName = "Button";
export {
  BUTTON_INTENT,
  BUTTON_INTENT_CLASSNAME_MAP,
  Button
};
